export default "__VITE_PUBLIC_ASSET__7a18b377__"